import React from 'react';
import PageHeader from '../../../Admin/Common/PageHeader';
import Loader from '../../../Component/Common/Loader';
import { toastError, toastIdSuccess } from '../../../SweetAlertUtil/util';
import UserService from '../../../Service/UserService';
import Session from '../../../Service/Session';
import axios from 'axios';
const APP_STRING = window.AppStrings;

let doc = [];
class UploadId extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            _fileUploaded: null,
            _isLoading: false,
            _tenant: null
        };
    }

    onChange = (e) => {
        if (e.target.files[0]) {
            doc = e.target.files[0]
            this.setState({
                _fileUploaded: e.target.files[0]
            });
        }
    }

    uploadIdProcedure = async () => {
        try {
            this.setState({ _isLoading: true });
            const typeObj = { type: 'putObject', fileName: this.state._fileUploaded.name };
            if (this.state._fileUploaded.size > 1E7) {
                toastError('Document size cannot exceed 10MB');
                this.setState({ _isLoading: false });
            } else if (!this.state._fileUploaded.type.startsWith("image/")) {
                toastError('Upload a valid image document');
                this.setState({ _isLoading: false });
            }
            else {
                const response = await UserService.signedUrlUploadId(this.props.currentUser.id, typeObj);
                await axios.put(response.data.signedUrl, doc, {
                    headers: {
                        'Content-Type': ''
                    }
                });
                this.setState({ _isLoading: false });
                if (response) {
                    const obj = { data: { data: this.state._fileUploaded.name } };
                    Session.store(APP_STRING.UPLOAD_ID, obj);
                    this.setState({ _fileUploaded: null });
                    toastIdSuccess('Your ID is uploaded successfully');
                    this.props.onBack();
                } else {
                    toastError('something went wrong');
                }
            }
        } catch (error) {
            this.setState({ _isLoading: false });
            toastError('something went wrong');
        }
    }


    render() {

        return (
            <>
                <PageHeader
                    text={`Replace uploaded ID`}
                />
                <div className="card">
                    <div className="card-body">
                        <table className="table table-bordered">

                            <tbody>

                                <tr>


                                    <td style={{ display: 'flex' }}>
                                        <div
                                            className="custom-file"
                                        >
                                            <input
                                                className="custom-file-input"
                                                id="customFile"
                                                name="customFile"
                                                onChange={(e) => this.onChange(e)}
                                                type="file"
                                                accept="image/*"
                                            />
                                            <label
                                                className="custom-file-label overflow-hidden"
                                                htmlFor="customFile"
                                            >{this.state._fileUploaded?.name || 'Choose file'}
                                            </label>
                                        </div>
                                        <button
                                            className="btn btn-block btn-success"
                                            onClick={() => { this.uploadIdProcedure(); }}
                                            style={{ width: '30%', marginLeft: '10px' }}
                                            type="button"
                                        >
                                            Upload
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-block btn-primary"
                                            onClick={() => { this.props.onBack(); }}
                                            type="button"
                                        >BACK
                                        </button>
                                    </td>

                                </tr>

                            </tbody>
                        </table>
                    </div>
                    {this.state._isLoading ? <Loader /> : null}
                </div>
            </>

        );
    }
}

export default UploadId;